import './mini-cart.component.pug'
import './mini-cart.component.scss'

const miniCart = document.querySelector('.mini-cart')

let miniCartState = false

function closeMiniCart() {
  miniCart.classList.remove('open')
  //window.removeEventListener('scroll', closeMiniCart)
  miniCartState = false
}

function openMiniCart() {
  miniCart.classList.add('open')
  //window.addEventListener('scroll', closeMiniCart, { once: true })
  miniCartState = true
}

const actionHandler = (action) => {
  if (action === 'close') {
    return closeMiniCart()
  }
  if (action === 'open') {
    return openMiniCart()
  }
}

if (miniCart) {
  document.addEventListener('click', (event) => {
    const targetButton = event.target.closest('[data-mini-cart-action]')
    if (targetButton && 'miniCartAction' in targetButton.dataset) {
      actionHandler(targetButton.dataset.miniCartAction)
    }
  })
}
